import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Users"),
    /*#__PURE__*/_createElementVNode("th", null, "Surveys"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_2 = { class: "region-buttons" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Cannot Delete. This Region is Tied to Users or Surveys", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_create_icon = _resolveComponent("create-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_delete_icon = _resolveComponent("delete-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_table = _resolveComponent("n-table")!
  const _component_RegionEditModal = _resolveComponent("RegionEditModal")!
  const _component_ConfirmRegionDeleteModal = _resolveComponent("ConfirmRegionDeleteModal")!
  const _component_CannotDeleteRegionModal = _resolveComponent("CannotDeleteRegionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_space, { justify: "space-between" }, {
      default: _withCtx(() => [
        _createVNode(_component_n_h1, null, {
          default: _withCtx(() => [
            _createTextVNode("Regions")
          ]),
          _: 1
        }),
        _createVNode(_component_n_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createRegion()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
              default: _withCtx(() => [
                _createVNode(_component_create_icon)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Create Region ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_n_table, {
          key: 0,
          bordered: false,
          "single-line": false,
          class: "region-list"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.sort((a, b) => Date.parse(b.createdOn) - Date.parse(a.createdOn)), (region) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: region.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(region.name), 1),
                  _createElementVNode("td", null, _toDisplayString(region.managerIds.length), 1),
                  _createElementVNode("td", null, _toDisplayString(region.surveyCount), 1),
                  _createElementVNode("td", _hoisted_2, [
                    _createVNode(_component_n_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, {
                          onClick: ($event: any) => (_ctx.editRegion(region.id))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_edit_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Edit ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_n_tooltip, {
                          placement: "bottom",
                          trigger: "hover",
                          disabled: region.managerIds.length <= 0 && region.surveyCount <= 0,
                          "aria-disabled": region.managerIds.length <= 0 && region.surveyCount <= 0
                        }, {
                          trigger: _withCtx(() => [
                            _createVNode(_component_n_button, {
                              onClick: ($event: any) => (_ctx.deleteRegion(region.id)),
                              tertiary: "",
                              class: "delete-button",
                              type: "error"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_delete_icon)
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" Delete ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["disabled", "aria-disabled"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_RegionEditModal, {
      region: (_ctx.selectedRegion as Region),
      regionalManagers: _ctx.regionManagers,
      showModal: _ctx.showEditModal,
      "onUpdate:showModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEditModal) = $event)),
      onRegionUpdate: _ctx.fetchRegions
    }, null, 8, ["region", "regionalManagers", "showModal", "onRegionUpdate"]),
    _createVNode(_component_ConfirmRegionDeleteModal, {
      region: (_ctx.selectedRegion as Region),
      showModal: _ctx.showDeleteModal,
      "onUpdate:showModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteModal) = $event)),
      onRegionUpdate: _ctx.fetchRegions
    }, null, 8, ["region", "showModal", "onRegionUpdate"]),
    _createVNode(_component_CannotDeleteRegionModal, {
      showModal: _ctx.showCannotDeleteModal,
      "onUpdate:showModal": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCannotDeleteModal) = $event))
    }, null, 8, ["showModal"])
  ], 64))
}